function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M375.98,40c-35.346,0-64,28.654-64,64c0.04,35.33,28.67,63.96,64,64c35.346,0,64-28.654,64-64 C439.98,68.654,411.326,40,375.98,40z M375.98,152c-26.51,0-48-21.49-48-48c0.026-26.499,21.501-47.974,48-48 c26.51,0,48,21.49,48,48S402.49,152,375.98,152z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 367.98,
  width: 16,
  height: 24
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 367.98,
  y: 184,
  width: 16,
  height: 24
})));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 271.98,
  y: 96,
  width: 24,
  height: 16
})));

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 455.98,
  y: 96,
  width: 24,
  height: 16
})));

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 302.921,
  y: 26.946,
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 63.5276 231.2613)",
  width: 16,
  height: 24
})));

var _ref8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 433.028,
  y: 157.037,
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 9.6468 361.3641)",
  width: 16,
  height: 24
})));

var _ref9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 298.924,
  y: 161.031,
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -28.4553 269.3647)",
  width: 24,
  height: 16
})));

var _ref10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 429.036,
  y: 30.943,
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 101.64 323.2658)",
  width: 24,
  height: 16
})));

var _ref11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M431.004,468.168l-192-352c-1.402-2.57-4.096-4.169-7.024-4.168h-224c-0.601,0.013-1.199,0.09-1.784,0.232 c-0.064,0-0.128,0-0.192,0c-0.78,0.209-1.522,0.538-2.2,0.976c-0.2,0.132-0.393,0.277-0.576,0.432 c-0.66,0.501-1.243,1.096-1.728,1.768c-0.112,0.168-0.264,0.304-0.368,0.48c-0.17,0.324-0.315,0.661-0.432,1.008 c-0.105,0.208-0.198,0.422-0.28,0.64c-0.255,0.775-0.39,1.584-0.4,2.4V176c-0.001,1.329,0.329,2.638,0.96,3.808l159.96,296 c1.399,2.584,4.102,4.194,7.04,4.192h256c4.418,0.001,8.001-3.58,8.001-7.999C431.982,470.662,431.646,469.344,431.004,468.168z  M362.5,376h-53.768l-39.272-72h53.768L362.5,376z M170.5,288h-61.768L69.46,216h61.768L170.5,288z M149.46,216h53.768l39.272,72 h-53.768L149.46,216z M179.228,304l39.272,72h-61.768l-39.272-72H179.228z M197.46,304h53.768l39.272,72h-53.768L197.46,304z  M314.5,288h-53.768l-39.272-72h53.768L314.5,288z M227.228,128l39.272,72h-53.768l-39.272-72H227.228z M155.228,128l39.272,72 h-53.768l-39.272-72H155.228z M83.228,128l39.272,72H60.732L21.46,128H83.228z M172.78,464L15.98,173.976v-22.6L186.5,464H172.78z  M204.732,464l-39.272-72h61.768l39.272,72H204.732z M284.732,464l-39.272-72h53.768l39.272,72H284.732z M356.732,464l-39.272-72 h53.768l39.272,72H356.732z"
})));

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

var _ref22 = /*#__PURE__*/React.createElement("g", null);

var _ref23 = /*#__PURE__*/React.createElement("g", null);

var _ref24 = /*#__PURE__*/React.createElement("g", null);

var _ref25 = /*#__PURE__*/React.createElement("g", null);

var _ref26 = /*#__PURE__*/React.createElement("g", null);

function Svg218(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    fill: "inherit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg218);
export default __webpack_public_path__ + "static/media/2_18.8aaa22d4.svg";
export { ForwardRef as ReactComponent };